<app-dialog
    [header]="header"
    [show]="true"
    [hasControls]="true"
    [saveBtnText]="isEditMode ? 'Save ' : 'Add '"
    [scrollable]="true"
    [disableSaveBtn]="loadingOrder$ | async"
    maxHeight="98hv"
    (save)="submitForm()"
    (cancel)="cancel.emit()"
    (onCancelKeyDown)="handleControlsTabbing()"
    (onSubmitKeyDown)="handleControlsTabbing()"
    #addEditPartyDialog
>
    <div class="body" [formGroup]="form">
        <div class="header">Company Details</div>
        <div class="form-row">
            <div formGroupName="orderParty" class="w-full">
                <!-- Autofocus only in add new entity mode -->
                <app-input 
                    [label]="'Company name'"
                    formControlName="companyName"
                    [type]="'text'"
                    [autofocus]="!isEditMode"
                    [showErrors]="true"
                    [errorMessage]="companyNameValidatorError"
                    [readOnly]="isEditMode"
                    [ignoreInput]="isEditMode"
                    #companyName
                ></app-input>
            </div>
            <app-input
                [label]="'Dea Number'"
                [autofocus]="isEditMode && type !== OrderPartyTypeEnum.Supplier"
                formControlName="deaNumber"
                [readOnly]="type === OrderPartyTypeEnum.Supplier"
                [ignoreInput]="type === OrderPartyTypeEnum.Supplier"
                #dea
            ></app-input>
        </div>
        <div class="form-row" formGroupName="physicalAddress">
            <app-input
                [label]="'Address 1'"
                formControlName="address1"
                [type]="'text'"
                [readOnly]="type === OrderPartyTypeEnum.Supplier"
                [ignoreInput]="type === OrderPartyTypeEnum.Supplier"
            ></app-input>
        </div>
        <div class="form-row" formGroupName="physicalAddress">
            <app-input
                [label]="'Address 2'"
                formControlName="address2"
                [type]="'text'"
                [readOnly]="type === OrderPartyTypeEnum.Supplier"
                [ignoreInput]="type === OrderPartyTypeEnum.Supplier"
            ></app-input>
        </div>
        <div class="form-row" formGroupName="physicalAddress">
            <app-input class="city"
                [label]="'City'"
                formControlName="city"
                [type]="'text'"
                [readOnly]="type === OrderPartyTypeEnum.Supplier"
                [ignoreInput]="type === OrderPartyTypeEnum.Supplier"
            ></app-input>
            <app-dropdown-with-overlay-options-list [isLoading]="loadingProfile$ | async"
                [label]="'State'"
                [placeholder]="'Chose State'"
                formControlName="state"
                [isOptionObject]="false"
                [options]="states$ | async"
                [highlightFocusedInput]="true"
                [disable]="type === OrderPartyTypeEnum.Supplier"
                (chosenOption)="dropdown.focus()"
                #dropdown
            ></app-dropdown-with-overlay-options-list>
            <app-input class="custom-input"
                [label]="'Zip code'"
                formControlName="zipCode"
                [type]="'number'"
                [maxLength]="5"
                [isZipCodeNumber]="true"
                [readOnly]="type === OrderPartyTypeEnum.Supplier"
                [ignoreInput]="type === OrderPartyTypeEnum.Supplier"
            ></app-input>
          </div>

          <app-checkbox 
           label="Use this address for shipping"
           [checked]="shippingAddressIsSameWithPhysical"
           (checkBoxToggled)="checkBoxValueChanged()"
           (change)="checkBoxValueChanged()"
          ></app-checkbox>

        <div class="header top-bordered pt-4" [hidden]="shippingAddressIsSameWithPhysical">Shipping Address</div>
          <div formGroupName="shippingAddress" [hidden]="shippingAddressIsSameWithPhysical" class="space-y-4 !mb-4">
            <div class="form-row">
                <app-input
                    [label]="'Address 1'"
                    formControlName="address1"
                    [autofocus]="isEditMode && type === OrderPartyTypeEnum.Supplier"
                    [type]="'text'"
                    #shippingAddress1
                ></app-input>
            </div>
            <div class="form-row">
                <app-input
                    [label]="'Address 2'"
                    formControlName="address2"
                    [type]="'text'"
                ></app-input>
            </div>
            <div class="form-row">
                <app-input class="city"
                           [label]="'City'"
                           formControlName="city"
                           [type]="'text'"
                ></app-input>
                <app-dropdown-with-overlay-options-list [isLoading]="loadingProfile$ | async"
                              [label]="'State'"
                              [placeholder]="'Chose State'"
                              formControlName="state"
                              [isOptionObject]="false"
                              [options]="states$ | async"
                              [highlightFocusedInput]="true"
                              (chosenOption)="dropdown.focus()"
                              #dropdown
                ></app-dropdown-with-overlay-options-list>
                <app-input class="custom-input"
                           [label]="'Zip code'"
                           formControlName="zipCode"
                           [type]="'number'"
                           [maxLength]="5"
                           [isZipCodeNumber]="true"
                           (keyupEnter)="handleShippingZipCodeTabbing()"
                           (keydownTab)="handleShippingZipCodeTabbing()"
                           #zip
                ></app-input>
              </div>
          </div>

          <div class="header top-bordered pt-4" *ngIf="type !== OrderPartyTypeEnum.Supplier && type !== OrderPartyTypeEnum.EdiBuyer">Contact Person</div>

          <div class="form-row" formGroupName="contactPerson" *ngIf="type !== OrderPartyTypeEnum.Supplier && type !== OrderPartyTypeEnum.EdiBuyer">
            <app-input 
                [label]="'First Name'"
                formControlName="firstName"
                [type]="'text'"
            ></app-input>
            <app-input 
                [label]="'Last Name'"
                formControlName="lastName"
                [type]="'text'"
                (keyupEnter)="form.valid ? addEditPartyDialog.focusSubmitButton() : addEditPartyDialog.focusCancelButton()"
                (keydownTab)="form.valid ? addEditPartyDialog.focusSubmitButton() : addEditPartyDialog.focusCancelButton()"
                #lastName
            ></app-input>
        </div>

    </div>
</app-dialog>